import * as R from 'ramda';
import uuidv4 from 'uuid/v4';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { withStyles } from '@material-ui/styles';
import { Grid, Typography, Button } from '@material-ui/core';
import { withReduxForm, Phone, Select, TypeSelect } from 'utilsModule/form/reduxFormMui';
import { Back } from 'utilsModule/components';
import Logo from 'appModule/logo/logoNoText';
import HeaderComponent from 'appModule/main/layouts/Header';

const styles = {
  pageContainer: {
    height: '84vh',
    width: '100vw',
    margin: 0,
    backgroundColor: '#fff',
    paddingBottom: 100
  },
  banner: {
    textAlign: 'center',
  },
  back: {
    height: '16vh',
    padding: 20,
    backgroundColor: '#fff',
  },
  title: {
    color: '#212121',
    textAlign: 'center',
    fontFamily: 'Roboto',
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 19,
  },
  subTitle: {
    color: '#212121',
    textAlign: 'center',
    fontFamily: 'Roboto',
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '19px',
  },
};

const layout = {
  header: {
    itemProps: {
      style: {
        marginBottom: 42,
      },
    },
    containerProps: {
      justify: 'center',
    },
    components: [
      {
        id: uuidv4(),
        name: 'banner',
        component: ({ title, subtitle }) => (
          <Grid container style={{ textAlign: 'center', }}>
            <Grid item xs={12}><Logo /></Grid>
            <Grid item xs={12} style={{ marginBottom: 16 }}><Typography variant='h4' styles={styles.title} style={{ letterSpacing: 0.5 }}>{title}</Typography></Grid>
            <Grid item xs={12}><Typography variant='body1' styles={styles.subTitle} style={{ letterSpacing: 0.5 }}>{subtitle}</Typography></Grid>
          </Grid>
        ),
        colSpans: { xs: 12 },
        inject: ({ runtimeProps: { header: { banner } } }) => banner,
      },
    ],
  },
  body: {
    sections: [
      {
        id: uuidv4(),
        name: 'loginInfo',
        containerProps: {
          body: {
            spacing: 1,
          },
        },
        rows: [
          {
            id: uuidv4(),
            containerProps: {
              justify: 'center',
              spacing: 0,
            },
            cols: [
              {
                name: 'mobile',
                label: 'Mobile Number',
                component: Phone,
                required: true,
                inject: ({ runtimeProps: { t } }) => ({ label: t('login.mobileNo') }),
                colSpans: { xs: 8 },
              },
            ],
          },
        ],
      },
    ],
  },
  footer: {
    itemProps: {
      style: {
        marginTop: 40,
      },
    },
    containerProps: {
      justify: 'center',
    },
    components: [
      {
        id: uuidv4(),
        component: Button,
        type: 'submit',
        children: 'Next',
        variant: 'contained',
        color: 'primary',
        style: { width: '100%' },
        className: 'milo-btn-submit-medium',
        colSpans: { xs: 6 },
        inject: ({ submitting, runtimeProps: { t } }) => ({
          disabled: submitting,
          children: t('common:buttonLabels.next')
        }),
      },
    ],
  },
};

const fieldGroups = R.pipe(
  R.map(({ name, rows }) => ({
    name: name || 'root',
    fields: R.flatten(R.map(R.prop('cols'), rows)),
  })),
  R.reduceBy((acc, { fields }) => acc.concat(fields), [], R.prop('name')),
  R.unless(R.prop('root'), R.assoc('root', [])),
)(layout.body.sections);

const validate = (values, props) => {
  const errors = {};

  const getFieldValue = (groupName, fieldName) => R.prop(fieldName, groupName === 'root' ? values : values[groupName]);
  const attachValueToField = (groupName) => (field) =>
    R.assoc(
      'value',
      R.contains(field.component, [Select, TypeSelect])
        ? R.prop('value', getFieldValue(groupName, field.name))
        : getFieldValue(groupName, field.name),
      field,
    );
  const fieldGroupsWithValue = R.mapObjIndexed(
    (groupFields, groupName) => R.map(attachValueToField(groupName), groupFields),
    fieldGroups,
  );
  const requiredFieldGroupsWithValue = R.map(
    R.filter(({ name, required }) => required),
    fieldGroupsWithValue,
  );

  const requiredPhoneFieldGroupsWithValue = R.map(
    R.filter(R.pipe(R.prop('component'), R.identical(Phone))),
    requiredFieldGroupsWithValue,
  );

  /* Validate Phone */
  R.mapObjIndexed(
    (groupFields, groupName) =>
      R.map(({ name, value: { countryCode: { value: countryCode } = {}, value } = {} }) => {
        !countryCode && (errors[groupName] = R.assocPath([name, 'countryCode'], 'Oops', errors[groupName]));
        !value && (errors[groupName] = R.assocPath([name, 'value'], props.t('forgetPassword.validationMessage.mobileNumberMissing'), errors[groupName]));
      }, groupFields),
    requiredPhoneFieldGroupsWithValue,
  );

  return errors;
};

const config = {
  form: 'forgetPassword',
  validate
};
@withStyles(styles, { index: 1 })
@withReduxForm({ layout, config })
class ForgetPassword extends PureComponent {
  static propTypes = {
    /* container */
    forgetPassword: PropTypes.func.isRequired,
    /* withStyles */
    classes: PropTypes.object,
    /* createReduxForm */
    Form: PropTypes.func.isRequired,
  };

  render() {
    const {
      classes,
      Form, initialValues, runtimeProps, forgetPassword, changePassword,
    } = this.props;

    return (
      <React.Fragment>
        <HeaderComponent isOnBoard={true} hideComponents={{ isDisclaimer: true }} />
        <div style={{ paddingTop: 50 }}>
          <Back className={classes.back} backToWebsite={!changePassword} />
          <Grid container className={classes.pageContainer} alignItems='center'>
            <Grid item xs />
            <Grid item xs={4}>
              <Form
                runtimeProps={runtimeProps}
                initialValues={initialValues}
                onSubmit={forgetPassword}
                t={runtimeProps.t}
              />
            </Grid>
            <Grid item xs />
          </Grid>
        </div>
      </React.Fragment>
    );
  }
}

export default ForgetPassword;
